<template>
  <div>
    <div class="bg-green home-hero home-section">
      <div class="home-hero-image">
        <img
          src="../assets/peoplelink.png"
          alt="People networking"
          srcset=""
          class="hero-image"
        />
      </div>
      <div class="register-now">
        <h1>{{ $t("home.hero-title") }}</h1>
        <p>{{ $t("home.hero-text") }}</p>
        <div class="register-form">
          <vue-tel-input v-model="phone" v-bind="telInputProps"></vue-tel-input>
          <input
            type="button"
            :value="$t('home.register')"
            class="submit-now"
          />
        </div>
      </div>
    </div>
    <div class="home-app home-section">
      <div class="app-screenshots">
        <img src="../assets/app-screenshots.png" alt="App Screenshots" />
      </div>
      <div class="app-download-area">
        <download-app />
      </div>
    </div>
    <div class="home-video home-section">
      <video controls poster="../assets/intro-video-cover.png">
        <source src="../assets/intro2.mp4" type="" />
      </video>
    </div>
    <div class="home-features bg-green2 home-section">
      <div class="features-container">
        <div class="home-feature-block">
          <h3>{{ $t("home.features.title1") }}</h3>
          <p>{{ $t("home.features.text1") }}</p>
        </div>
        <div class="home-feature-block">
          <h3>{{ $t("home.features.title2") }}</h3>
          <p>{{ $t("home.features.text2") }}</p>
        </div>
        <div class="home-feature-block">
          <h3>{{ $t("home.features.title3") }}</h3>
          <p>{{ $t("home.features.text3") }}</p>
        </div>
        <div class="home-feature-block">
          <h3>{{ $t("home.features.title4") }}</h3>
          <p>{{ $t("home.features.text4") }}</p>
        </div>
        <div class="home-feature-block">
          <h3>{{ $t("home.features.title5") }}</h3>
          <p>{{ $t("home.features.text5") }}</p>
        </div>
        <div class="home-feature-block">
          <h3>{{ $t("home.features.title6") }}</h3>
          <p>{{ $t("home.features.text6") }}</p>
        </div>
      </div>
      <hr />
      <div class="features-container">
        <div class="feature-icon-block">
          <div class="feature-icon">
            <img src="../assets/icon-tools.png" alt="Tools Icon" />
          </div>
          <div class="feature-content">
            <h4>{{ $t("home.features.icon-title1") }}</h4>
            <p>{{ $t("home.features.icon-text1") }}</p>
          </div>
        </div>
        <div class="feature-icon-block">
          <div class="feature-icon">
            <img src="../assets/icon-headset.png" alt="Headset Icon" />
          </div>
          <div class="feature-content">
            <h4>{{ $t("home.features.icon-title2") }}</h4>
            <p>{{ $t("home.features.icon-text2") }}</p>
          </div>
        </div>
        <div class="feature-icon-block">
          <div class="feature-icon">
            <img src="../assets/icon-medal.png" alt="Medal Icon" />
          </div>
          <div class="feature-content">
            <h4>{{ $t("home.features.icon-title3") }}</h4>
            <p>{{ $t("home.features.icon-text3") }}</p>
          </div>
        </div>
        <div class="feature-icon-block">
          <div class="feature-icon">
            <img src="../assets/icon-speaker.png" alt="Speaker Icon" />
          </div>
          <div class="feature-content">
            <h4>{{ $t("home.features.icon-title4") }}</h4>
            <p>{{ $t("home.features.icon-text4") }}</p>
          </div>
        </div>
        <div class="feature-icon-block">
          <div class="feature-icon">
            <img src="../assets/icon-barchart.png" alt="Barchart Icon" />
          </div>
          <div class="feature-content">
            <h4>{{ $t("home.features.icon-title5") }}</h4>
            <p>{{ $t("home.features.icon-text5") }}</p>
          </div>
        </div>
        <div class="feature-icon-block">
          <div class="feature-icon">
            <img src="../assets/icon-mic.png" alt="Mic Icon" />
          </div>
          <div class="feature-content">
            <h4>{{ $t("home.features.icon-title6") }}</h4>
            <p>{{ $t("home.features.icon-text6") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="home-register home-section">
      <div class="content">
        <div>
          <img src="../assets/icon-nft.png" alt="NFT Icon" />
        </div>
        <div class="register-now">
          <p v-html="$t('home.nftregistertext1')"></p>
          <p>
            <b>{{ $t("home.nftregistertext2") }}</b>
          </p>
          <div class="register-form">
            <vue-tel-input
              v-model="phone"
              v-bind="telInputProps"
            ></vue-tel-input>
            <input
              type="button"
              :value="$t('home.register')"
              class="submit-now"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="home-download bg-green3 home-section">
      <h1>{{ $t("home.downloadtitle") }}</h1>
      <div class="download">
        <div>
          <img src="../assets/gcoin.png" alt="GCoin" />
        </div>
        <div>
          <h5>{{ $t("download.download-text") }}</h5>
          <div class="stores">
            <div>
              <a href="https://goldenlinkplus.net/000/g1.2.apk">
                <img
                  src="../assets/GetItOnGooglePlay.png"
                  alt="Google Play"
                  srcset=""
                />
              </a>
            </div>
            <div>
              <a href="https://testflight.apple.com/join/LPHHa2CK">
                <img
                  src="../assets/Download_on_the_App_Store.svg"
                  alt="Apple App Store"
                  srcset=""
                />
              </a>
            </div>
          </div>
        </div>
        <div>
          <img src="../assets/gs.png" alt="GS" />
        </div>
      </div>
    </div>
    <div class="home-section">
      <img src="../assets/people.png" alt="People" class="people-collage" />
    </div>
    <div class="home-last-links bg-green3 home-section">
      <div class="register-link">
        <h3>{{ $t("home.empowertitle") }}</h3>
        <p>{{ $t("home.excited") }}</p>
        <div class="register-form">
          <vue-tel-input v-model="phone" v-bind="telInputProps"></vue-tel-input>
          <input
            type="button"
            :value="$t('home.register')"
            class="submit-now"
          />
        </div>
      </div>
      <div class="app-download-links">
        <download-app />
      </div>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
import DownloadApp from "@/components/DownloadApp.vue";
export default {
  components: {
    VueTelInput,
    DownloadApp,
  },
  data() {
    return {
      phone: "",
      telInputProps: {
        defaultCountry: "US",
        inputOptions: {
          placeholder: "(555) 555-5254",
          showDialCode: true,
          styleClasses: 'dj-vue-tel-input',
        },
      },
    };
  },
};
</script>
<style src="vue-tel-input/dist/vue-tel-input.css"></style>
<style scoped>
.home-section {
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}
.home-hero {
  padding: 100px 3rem 15rem;
  align-items: flex-start;
  flex-wrap: wrap;
  .home-hero-image {
    width: 100%;
    text-align: center;
    img {
      width: 80%;
    }
  }
  .register-now {
    width: 100%;
    box-sizing: border-box;
    padding: 0;
    white-space: pre-line;
    h1 {
      font-family: "Poppins", sans-serif;
      font-size: 11vw;
      font-weight: 700;
      line-height: 11.5vw;
      letter-spacing: -0.05em;
      text-align: center;
      padding: 0;
      margin: 1rem 0;
    }
    p {
      font-weight: 400;
      font-size: 1.2rem;
    }
  }
}
.register-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  input {
    height: 9vw;
    border-radius: 0;
    border-bottom-right-radius: 2vw;
    border-bottom-left-radius: 2vw;
    font-family: "Poppins", sans-serif;
  }
  .vue-tel-input {
    padding: 0.5rem;
    background-color: white;
    width: 90%;
    height: 9vw;
    font-size: 2.5vw;
    line-height: 3.5vw;
    box-sizing: border-box;
    border: none;
    box-shadow: 0px 4px 20px 0px #0000000d !important;
    border-radius: 0;
    border-top-left-radius: 2vw;
    border-top-right-radius: 2vw;
  }
  .submit-now {
    background-color: #ef8200;
    font-family: "Poppins", sans-serif;
    font-size: 2.5vw;
    font-weight: 700;
    line-height: 3.5vw;
    text-align: center;
    color: white;
    border: none;
    width: 90%;
    box-shadow: 0px 4px 20px 0px #0000000d !important;
  }
}
.home-app {
  flex-wrap: wrap;
  .app-screenshots {
    display: block;
    margin-top: -10rem;
    text-align: center;
    width: 100%;
    img {
      width: 80%;
    }
  }
  .app-download-area {
    width: 100%;
    margin-top: 3rem;
  }
}
.home-video {
  text-align: center;
  margin-top: 3rem;
  video {
    width: 80%;
    border: 1rem solid #70BCE5;
    border-radius: 0.5rem;
  }
}
.home-features {
  padding: 22rem 0 2rem;
  flex-direction: column;
  align-items: center;
  margin-top: -18rem;
  .features-container {
    display: flex;
    width: 90%;
    justify-content: space-around;
    flex-wrap: wrap;
    .home-feature-block {
      width: 100%;
      border: 1px solid #f4f9fe;
      background-color: white;
      box-shadow: 0px 4px 20px 0px #0000000d;
      margin-bottom: 2rem;
      text-align: left;
      padding: 1rem;
      box-sizing: border-box;
      border-radius: 0.5rem;
      h3 {
        color: #ef8200;
        font-size: 5.5vw;
        margin: 0;
      }
      p {
        color: #3b3e51;
        font-size: 4vw;
        margin-bottom: 0;
      }
    }
    .feature-icon-block {
      width: 100%;
      padding: 1rem 0;
      box-sizing: border-box;
      border-radius: 0.5rem;
      display: flex;
      align-items: flex-start;
      .feature-icon {
        width: 10%;
        img {
          display: block;
        }
      }
      .feature-content {
        width: 90%;
        padding: 0;
        padding-left: 1rem;
        box-sizing: border-box;
        h4 {
          margin: 0;
          color: #3daec9;
          font-size: 5.5vw;
        }
        p {
          margin: 0;
          color: #3b3e51;
          font-size: 4vw;
        }
      }
    }
  }
  hr {
    width: 80%;
    height: 1px;
    border: none;
    background-color: #3daec9;
  }
}
.home-register {
  background-color: #3b3e51;
  padding: 5rem 0;
  .content {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
    font-size: 1.5rem;
    .register-now {
      padding: 0;
    }
  }
}
.home-download {
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 5rem 0;
  h1 {
    color: #ef8200;
    font-size: 2rem;
  }
  .download {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    align-items: center;
    width: 100%;
    img {
      width: 120px;
    }
    h5 {
      text-align: center;
      width: 100%;
      color: #3b3e51;
      font-size: 1.2rem;
      margin: 0;
      margin-bottom: 1rem;
    }
    div {
      width: 100%;
      .stores {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        div {
          width: 50%;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
}
.people-collage {
  width: 100%;
}
.home-last-links {
  padding: 3rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  .register-link {
    width: 100%;
    h3 {
      color: #ef8200;
      font-size: 8vw;
      margin: 0;
    }
    p {
      color: #3daec9;
      font-size: 6.5vw;
      font-weight: bold;
    }
  }
  .app-download-links {
    display: none;
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .home-section {
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .home-hero {
    padding: 100px 3rem 15rem;
    align-items: flex-start;
    flex-wrap: wrap;
    .home-hero-image {
      width: 100%;
      text-align: center;
      img {
        width: 80%;
      }
    }
    .register-now {
      width: 100%;
      box-sizing: border-box;
      padding: 0;
      white-space: pre-line;
      h1 {
        font-family: "Poppins", sans-serif;
        font-size: 11.8vw;
        font-weight: 700;
        line-height: 12vw;
        letter-spacing: -0.05em;
        text-align: center;
        padding: 0;
        margin: 1rem 0;
      }
      p {
        font-weight: 400;
        font-size: 1.2rem;
      }
    }
  }
  .home-features {
    flex-direction: column;
    align-items: center;
    margin-top: -18rem;
    .features-container {
      display: flex;
      width: 80%;
      justify-content: space-around;
      flex-wrap: wrap;
      .home-feature-block {
        width: 48%;
        border: 1px solid #f4f9fe;
        background-color: white;
        box-shadow: 0px 4px 20px 0px #0000000d;
        margin-bottom: 2rem;
        text-align: left;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        h3 {
          color: #ef8200;
          font-size: 1.5rem;
          margin: 0;
        }
        p {
          color: #3b3e51;
          font-size: 0.8rem;
          margin-bottom: 0;
        }
      }
      .feature-icon-block {
        width: 48%;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        display: flex;
        align-items: flex-start;
        img {
          display: block;
        }
        .feature-content {
          padding: 0 1rem;
          box-sizing: border-box;
          h4 {
            margin: 0;
            color: #3daec9;
            font-size: 1.2rem;
          }
          p {
            margin: 0;
            color: #3b3e51;
            font-size: 0.8rem;
          }
        }
      }
    }
    hr {
      width: 80%;
      height: 1px;
      border: none;
      background-color: #3daec9;
    }
  }
  .home-register {
    background-color: #3b3e51;
    padding: 5rem 0;
    .content {
      width: 80%;
      display: flex;
      justify-content: center;
      color: white;
      font-size: 1.5rem;
      .register-now {
        padding-left: 1rem;
      }
    }
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .home-section {
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .home-hero {
    align-items: flex-start;
    .home-hero-image {
      width: 38%;
      img {
        width: 100%;
      }
    }
    .register-now {
      width: 62%;
      box-sizing: border-box;
      padding-left: 1.5rem;
      white-space: pre-line;
      h1 {
        font-family: "Poppins", sans-serif;
        font-size: 6.5vw;
        font-weight: 900;
        line-height: 7vw;
        letter-spacing: -0.05em;
        text-align: left;
        padding: 0;
        margin: 0;
      }
      p {
        font-weight: 600;
        font-size: 1.2rem;
      }
    }
  }
  .register-form {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    input {
      height: 60px;
      border-radius: 0;
      border-top-right-radius: 1rem;
      border-bottom-right-radius: 1rem;
      font-family: "Poppins", sans-serif;
    }
    .vue-tel-input {
      padding: 0.5rem;
      background-color: white;
      width: 47%;
      height: 60px;
      font-size: 1rem;
      line-height: 1.5rem;
      box-sizing: border-box;
      border: none;
      box-shadow: 0px 4px 20px 0px #0000000d !important;
      border-radius: 0;
      border-top-left-radius: 1rem;
      border-bottom-left-radius: 1rem;
    }
    .vti__dropdown {
      padding: 0;
      font-size: 1rem;
    }
    .submit-now {
      background-color: #ef8200;
      font-family: "Poppins", sans-serif;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      color: white;
      border: none;
      width: 188px;
      box-shadow: 0px 4px 20px 0px #0000000d !important;
    }
  }
  .home-app {
    .app-screenshots {
      display: block;
      margin-top: -10rem;
      text-align: center;
      width: 60%;
    }
    .app-download-area {
      width: 40%;
      margin-top: 3rem;
    }
  }
  .home-video {
    text-align: center;
    video {
      width: 80%;
      border: none;
      border-radius: 0;
    }
  }
  .home-features {
    padding: 22rem 5rem 2rem;
    flex-direction: column;
    align-items: center;
    margin-top: -18rem;
    .features-container {
      display: flex;
      width: 100%;
      justify-content: space-around;
      flex-wrap: wrap;
      .home-feature-block {
        width: 48%;
        border: 1px solid #f4f9fe;
        background-color: white;
        box-shadow: 0px 4px 20px 0px #0000000d;
        margin-bottom: 2rem;
        text-align: left;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        h3 {
          color: #ef8200;
          font-size: 1.5rem;
          margin: 0;
        }
        p {
          color: #3b3e51;
          font-size: 0.8rem;
          margin-bottom: 0;
        }
      }
      .feature-icon-block {
        width: 48%;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        display: flex;
        align-items: flex-start;
        img {
          display: block;
        }
        .feature-content {
          padding: 0 1rem;
          box-sizing: border-box;
          h4 {
            margin: 0;
            color: #3daec9;
            font-size: 1.2rem;
          }
          p {
            margin: 0;
            color: #3b3e51;
            font-size: 0.8rem;
          }
        }
      }
    }
    hr {
      width: 80%;
      height: 1px;
      border: none;
      background-color: #3daec9;
    }
  }
  .home-register {
    background-color: #3b3e51;
    padding: 5rem 0;
    .content {
      width: 80%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      text-align: start;
      color: white;
      font-size: 1.5rem;
      .register-now {
        padding-left: 1rem;
      }
    }
  }
  .home-download {
    flex-direction: column;
    align-items: center;
    padding: 5rem 0;
    h1 {
      color: #ef8200;
      font-size: 2rem;
    }
    .download {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      img {
        width: 120px;
      }
      h5 {
        text-align: center;
        width: 100%;
        color: #3b3e51;
        font-size: 1.2rem;
        margin: 0;
        margin-bottom: 1rem;
      }
      div {
        width: auto;
        .stores {
          flex-direction: row;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          div {
            height: 50px;
            img {
              height: 100%;
              width: auto;
            }
          }
        }
      }
    }
  }
  .people-collage {
    width: 100%;
  }
  .home-last-links {
    padding: 3rem;
    flex-direction: row;
    text-align: start;
    .register-link {
      width: 60%;
      h3 {
        color: #ef8200;
        font-size: 2rem;
        margin: 0;
      }
      p {
        color: #3daec9;
        font-size: 1.2rem;
        font-weight: bold;
      }
    }
    .app-download-links {
      display: block;
      width: 40%;
    }
  }
}
/* X-Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .home-section {
    width: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .home-hero {
    padding: 2rem 3rem 15rem;
    align-items: flex-start;
    .register-now {
      width: 62%;
      box-sizing: border-box;
      padding-left: 1.5rem;
      white-space: pre-line;
      h1 {
        font-family: "Poppins", sans-serif;
        font-size: 85px;
        font-weight: 900;
        line-height: 100px;
        letter-spacing: -0.05em;
        text-align: left;
        padding: 0;
        margin: 0;
      }
      p {
        font-weight: 600;
        font-size: 1.2rem;
      }
    }
  }
  .register-form {
    display: flex;
    input {
      height: 60px;
      border-top-right-radius: 1rem;
      border-bottom-right-radius: 1rem;
      font-family: "Poppins", sans-serif;
    }
    .vue-tel-input {
      padding: 0.5rem;
      background-color: white;
      width: 47%;
      border: none;
      box-shadow: 0px 4px 20px 0px #0000000d !important;
      border-radius: 0;
      border-top-left-radius: 1rem;
      border-bottom-left-radius: 1rem;
    }
    .vti__dropdown {
      padding: 0;
      font-size: 1rem;
    }
    .submit-now {
      background-color: #ef8200;
      font-family: "Poppins", sans-serif;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      text-align: center;
      color: white;
      border: none;
      width: 188px;
      box-shadow: 0px 4px 20px 0px #0000000d !important;
    }
  }
  .home-app {
    .app-screenshots {
      display: block;
      margin-top: -10rem;
      text-align: center;
      width: 60%;
    }
    .app-download-area {
      width: 40%;
      margin-top: 3rem;
    }
  }
  .home-video {
    text-align: center;
    video {
      width: 80%;
    }
  }
  .home-features {
    padding: 22rem 5rem 2rem;
    flex-direction: column;
    align-items: center;
    margin-top: -18rem;
    .features-container {
      display: flex;
      width: 100%;
      justify-content: space-around;
      flex-wrap: wrap;
      .home-feature-block {
        width: 48%;
        border: 1px solid #f4f9fe;
        background-color: white;
        box-shadow: 0px 4px 20px 0px #0000000d;
        margin-bottom: 2rem;
        text-align: left;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        h3 {
          color: #ef8200;
          font-size: 1.5rem;
          margin: 0;
        }
        p {
          color: #3b3e51;
          font-size: 0.8rem;
          margin-bottom: 0;
        }
      }
      .feature-icon-block {
        width: 48%;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        display: flex;
        align-items: flex-start;
        img {
          display: block;
        }
        .feature-content {
          padding: 0 1rem;
          box-sizing: border-box;
          h4 {
            margin: 0;
            color: #3daec9;
            font-size: 1.2rem;
          }
          p {
            margin: 0;
            color: #3b3e51;
            font-size: 0.8rem;
          }
        }
      }
    }
    hr {
      width: 80%;
      height: 1px;
      border: none;
      background-color: #3daec9;
    }
  }
  .home-register {
    background-color: #3b3e51;
    padding: 5rem 0;
    .content {
      width: 80%;
      display: flex;
      justify-content: center;
      color: white;
      font-size: 1.5rem;
      .register-now {
        padding-left: 1rem;
      }
    }
  }
  .home-download {
    flex-direction: column;
    align-items: center;
    padding: 5rem 0;
    h1 {
      color: #ef8200;
      font-size: 2rem;
    }
    .download {
      display: flex;
      gap: 1rem;
      align-items: center;
      img {
        width: 120px;
      }
      h5 {
        text-align: center;
        width: 100%;
        color: #3b3e51;
        font-size: 1.2rem;
        margin: 0;
        margin-bottom: 1rem;
      }
      .stores {
        a:first-child {
          margin-right: 1rem;
        }
        img {
          height: 50px;
          width: auto;
        }
      }
    }
  }
  .people-collage {
    width: 100%;
  }
  .home-last-links {
    padding: 3rem;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
    .register-link {
      width: 60%;
      h3 {
        color: #ef8200;
        font-size: 2rem;
        margin: 0;
      }
      p {
        color: #3daec9;
        font-size: 1.2rem;
        font-weight: bold;
      }
    }
    .app-download-links {
      width: 40%;
    }
  }
}
</style>
